import cn from 'classnames';
import { Grid } from 'ht-styleguide';
import styles from '../locationPage.module.scss';

type CoveredBlockProps = {
  location: string;
};

const CoveredBlock = ({ location }: CoveredBlockProps) => (
  <section className={cn('paddingY-huge', styles.coveredContainer)}>
    <Grid.Fluid>
      <Grid.Row>
        <Grid.Column lg={4} lgOffset={4} classes="text-align-center">
          <h4 className="paddingBottom-small1">We’ve got you covered</h4>
          <p className="p1 n700">
            Whether you need a virus removed, a video doorbell installed, a thermostat set up, a TV mounted, your WiFi adjusted, or anything in
            between, HelloTech has {location} covered.
          </p>
        </Grid.Column>
      </Grid.Row>
    </Grid.Fluid>
  </section>
);

export default CoveredBlock;
